export const environment = {
  production: true,
  backendUrl: 'https://apphub.portoseguro.com.br'
  //backendUrl: 'https://ressarcimento-propostas-app-prd-psg-juridico-recupera.apps.ocppr.portoseguro.brasil'
};